import angular from 'angular'
import FanPlantillas from './plantillas'
import FanProyecto from './proyecto'
import FanProyectos from './proyectos'

export default angular.module('fan', [
  FanPlantillas,
  FanProyecto,
  FanProyectos,
])



// WEBPACK FOOTER //
// ./src/fan/module.js